var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"no-autoinit",attrs:{"name":_vm.name,"id":_vm.name},on:{"change":_vm.onChange}},_vm._l((_vm.cities),function(city){return _c('option',{key:city.code,attrs:{"disabled":city.code == _vm.disabled},domProps:{"value":city.code,"selected":city.code == _vm.selected ? 'selected' : ''}},[_vm._v(" "+_vm._s(city.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }